import { DefaultApproverNames } from "@/components/incoming-invoices";
import { useIncomingInvoiceDefaultApprovers } from "@/hooks/use-incoming-invoice-default-approvers";

/** Props Interface */
interface WorkspaceDefaultApproversProps {
	workspaceId: string;
}

export function WorkspaceDefaultApprovers({ workspaceId }: WorkspaceDefaultApproversProps) {
	/** Query */
	const { defaultApprovers } = useIncomingInvoiceDefaultApprovers();

	/** Computed */
	const approverNames: string[] = [];
	for (const approver of defaultApprovers) {
		if (approver.workspaceId === workspaceId && approver.user.name) {
			approverNames.push(approver.user.name);
		}
	}

	/** Render */
	return (
		<DefaultApproverNames
			workspaceId={workspaceId}
			approverNames={approverNames}
		/>
	);
}
